export interface PathPoint {
  x: number
  y: number
}

const CURVE_FACTOR = 1 / 6

function clamp(value: number, first: number, second: number) {
  return Math.max(Math.min(first, second), Math.min(Math.max(first, second), value))
}

function format(value: number) {
  return value.toFixed(2)
}

export function buildSmoothPath(points: PathPoint[]) {
  const validPoints = points.filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y))
  if (validPoints.length === 0) return ''

  const first = validPoints[0]
  let path = `M ${format(first.x)} ${format(first.y)}`
  if (validPoints.length === 1) return path
  if (validPoints.length === 2) {
    const last = validPoints[1]
    return `${path} L ${format(last.x)} ${format(last.y)}`
  }

  for (let index = 0; index < validPoints.length - 1; index += 1) {
    const previous = validPoints[index - 1] ?? validPoints[index]
    const current = validPoints[index]
    const next = validPoints[index + 1]
    const following = validPoints[index + 2] ?? next
    const controlOne = {
      x: clamp(current.x + (next.x - previous.x) * CURVE_FACTOR, current.x, next.x),
      y: clamp(current.y + (next.y - previous.y) * CURVE_FACTOR, current.y, next.y),
    }
    const controlTwo = {
      x: clamp(next.x - (following.x - current.x) * CURVE_FACTOR, current.x, next.x),
      y: clamp(next.y - (following.y - current.y) * CURVE_FACTOR, current.y, next.y),
    }
    path += ` C ${format(controlOne.x)} ${format(controlOne.y)} ${format(controlTwo.x)} ${format(controlTwo.y)} ${format(next.x)} ${format(next.y)}`
  }

  return path
}
